import { useEffect, useState } from "react";
import { getResourceKit } from "../../../../../services/customers/customers.services";
import KitImgList from "./kit-image-list.component";

export default function KitList() {
  const [resources, setResources] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getResourceKitPageData = async () => {
    try {
      const result = await getResourceKit();
      result.data && setResources(result.data.items);
      result.data && setCategories(result.data.categories);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getResourceKitPageData();
  }, []);

  const filterByCategoryId = (categoryId) => {
    return resources.filter((item) => item.customerHubCategoryId === categoryId);
  };

  if (isLoading) {
    return <></>;
  }

  return (
    <>
      {categories?.map((category, index) => (
        <KitImgList key={index} category={category} images={filterByCategoryId(category.pKey)} />
      ))}
    </>
  );
}
